
import { Component, Vue } from 'vue-property-decorator'
import { apiInvoiceLists, apiInvoiceDetail, apiInvoiceExport } from '@/api/order/invoice'
import ExportData from '@/components/export-data/index.vue'

@Component({ components: { ExportData } })
export default class Invoice extends Vue {
    apiInvoiceExport = apiInvoiceExport
    query: any = { sid: '', order_sn: '', status: '', page_no: 1, page_size: 10 }
    lists: any[] = []
    count = 0
    loading = false
    dialog = false
    current: any = {}
    statusMap: any = { 1: '待审核', 2: '已通过', 3: '已驳回', 4: '已开具' }
    async load(page = this.query.page_no) {
        this.loading = true
        try {
            this.query.page_no = page
            const data: any = await apiInvoiceLists(this.query)
            this.lists = data.lists || []
            this.count = data.count || 0
        } finally { this.loading = false }
    }
    async detail(row: any) { this.current = await apiInvoiceDetail({ id: row.id }); this.dialog = true }
    reset() { this.query = { sid: '', order_sn: '', status: '', page_no: 1, page_size: 10 }; this.load(1) }
    created() { this.load() }
}
